export const name = 'activePopup' as const
